var _path, _rect, _rect2, _rect3, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5H21.5V11V20C21.5 21.3807 20.3807 22.5 19 22.5H5C3.61929 22.5 2.5 21.3807 2.5 20V11V10.5H3H21Z",
    fill: "white",
    stroke: "#797979"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 2,
    height: 2,
    fill: "#E57200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 2,
    height: 2,
    fill: "#E57200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    width: 2,
    height: 2,
    fill: "#E57200"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_3143_7062",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2,
    y: 1,
    width: 20,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2H8V4H16V2H17V4H19C20.1046 4 21 4.89543 21 6V8H3V6C3 4.89543 3.89543 4 5 4H7V2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2H8V4H16V2H17V4H19C20.1046 4 21 4.89543 21 6V8H3V6C3 4.89543 3.89543 4 5 4H7V2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H9V1H8V2ZM7 2V1H6V2H7ZM8 4H7V5H8V4ZM16 4V5H17V4H16ZM16 2V1H15V2H16ZM17 2H18V1H17V2ZM17 4H16V5H17V4ZM21 8V9H22V8H21ZM3 8H2V9H3V8ZM7 4V5H8V4H7ZM8 1H7V3H8V1ZM9 4V2H7V4H9ZM16 3H8V5H16V3ZM17 4V2H15V4H17ZM16 3H17V1H16V3ZM16 2V4H18V2H16ZM19 3H17V5H19V3ZM22 6C22 4.34315 20.6569 3 19 3V5C19.5523 5 20 5.44772 20 6H22ZM22 8V6H20V8H22ZM3 9H21V7H3V9ZM2 6V8H4V6H2ZM5 3C3.34315 3 2 4.34315 2 6H4C4 5.44772 4.44772 5 5 5V3ZM7 3H5V5H7V3ZM6 2V4H8V2H6Z",
    fill: "#797979",
    mask: "url(#path-5-outside-1_3143_7062)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/DatePickerIcon.16cf0a7fc0951b65f6fbf171c05ee126.svg";
export { ForwardRef as ReactComponent };